import { includes } from 'ramda';

import { USER_ROLES } from 'constants/general';
import fetch from 'features/common/fetch';
import { getCurrentRole } from 'features/views/user/selectors';

import { productDomains } from './constants';
import {
	setCampaignsNearingTheEndContactRelease,
	setCampaignsNearingTheEndManager,
	setEscalationBasic,
	setEscalationSummary,
	setLeadsInProgress,
	setLeadsToProcess,
	setUnpaidFirstPayment,
} from './slice';

export const startupTodaysUrgencies = () => (dispatch, getState) => {
	const currentRole = getCurrentRole(getState());

	if (includes(currentRole, [USER_ROLES.SELLER, USER_ROLES.PPZ])) {
		dispatch(fetchUnpaidFirstPaymentList());
		dispatch(fetchLeadsInProgress());
	}

	if (currentRole === USER_ROLES.GROUP_MANAGER) {
		dispatch(fetchEscalationBasic());
		dispatch(fetchEscalationSummary());
		dispatch(fetchCampaignsNearingTheEndManager());
		dispatch(fetchCampaignsNearingTheEndContactRelease());
		dispatch(fetchLeadsToProcess());
	}
};

export const fetchEscalationBasic = () => (dispatch) => {
	dispatch(
		fetch.actions.get(fetch.constants.urls.escalationBasic, {
			onSuccess: [
				(response) => () => {
					const body = response?.body;
					dispatch(setEscalationBasic(body));
				},
			],
		}),
	);
};

export const fetchEscalationSummary = () => (dispatch) => {
	dispatch(
		fetch.actions.get(fetch.constants.urls.escalationSummary, {
			onSuccess: [
				(response) => () => {
					const body = response?.body;
					dispatch(setEscalationSummary(body));
				},
			],
		}),
	);
};

export const fetchCampaignsNearingTheEndManager = () => (dispatch) => {
	dispatch(
		fetch.actions.get(fetch.constants.urls.campaignsNearingTheEndManager, {
			onSuccess: [
				(response) => () => {
					const body = response?.body;
					dispatch(setCampaignsNearingTheEndManager(body));
				},
			],
		}),
	);
};

export const fetchCampaignsNearingTheEndContactRelease = () => (dispatch) => {
	dispatch(
		fetch.actions.get(fetch.constants.urls.campaignsNearingTheEndContactRelease, {
			onSuccess: [
				(response) => () => {
					const body = response?.body;
					dispatch(setCampaignsNearingTheEndContactRelease(body));
				},
			],
		}),
	);
};

export const fetchLeadsToProcess = () => (dispatch) => {
	dispatch(
		fetch.actions.get(fetch.constants.urls.leadsToProcess, {
			onSuccess: [
				(response) => () => {
					const body = response?.body;
					dispatch(setLeadsToProcess(body));
				},
			],
		}),
	);
};

export const fetchUnpaidFirstPaymentList = () => (dispatch) => {
	const productDomainsArr = Object.keys(productDomains);

	productDomainsArr.forEach((productDomain) => {
		dispatch(fetchUnpaidFirstPayment(productDomain));
	});
};

export const fetchUnpaidFirstPayment = (productDomain) => (dispatch, getState) => {
	const isFetching = fetch.selectors.getIsFetching(`${fetch.constants.urls.unpayedFirstPayment}.${productDomain}`)(
		getState(),
	);

	!isFetching &&
		dispatch(
			fetch.actions.get(fetch.constants.urls.unpayedFirstPayment, {
				uniqueReqID: productDomain,
				replaceParams: { productDomain },
				onSuccess: [
					(response) => () => {
						const body = response?.body;
						dispatch(setUnpaidFirstPayment({ [productDomain]: body?.total }));
					},
				],
			}),
		);
};

export const fetchLeadsInProgress = () => (dispatch) => {
	dispatch(
		fetch.actions.get(fetch.constants.urls.leadsInProgress, {
			onSuccess: [
				(response) => () => {
					const body = response?.body;
					dispatch(setLeadsInProgress(body?.total));
				},
			],
		}),
	);
};
